var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('RolesHead',{attrs:{"showFilter":_vm.showFilter},on:{"toggleFilter":_vm.toggleFilter}}),_c('div',{staticClass:"table-filter-wrap"},[_c('RolesFilter',{attrs:{"showFilter":_vm.showFilter},on:{"close":_vm.closeFilter}}),_c('RolesTable',{on:{"getRoles":_vm.getRoles}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }